import axios from 'axios';

export default class HttpUtil  {

	static buildHeaders() {
		let headers = {};
		headers['Content-Type'] = 'application/json';
		return headers;
	}

	// static buildHeaders(strHeaderKey, strHeaderValue) {
	// 	let headers = {};
	// 	headers[strHeaderKey] = strHeaderValue;
		
	// 	return headers;
	// }

	// POST
	static eco_POST(url, parameters, callback, errorCallback) {
		let reqHeaders = this.buildHeaders();
		return axios.post(url, parameters, {
			headers: reqHeaders
		}).then(callback).catch(errorCallback);
	}

	// POST
	static eco_POST_CONFIG(url, parameters, config, callback, errorCallback) {
		return axios.post(url, parameters, config).then(callback).catch(errorCallback);
	}

	// GET
	static eco_GET(url, callback, errorCallback) {
		let reqHeaders = this.buildHeaders();
		return axios.get(url, {
			headers: reqHeaders
		}).then(callback).catch(errorCallback);
	}
	
	// PUT
	static eco_PUT(url, parameters, callback, errorCallback) {
		let reqHeaders = this.buildHeaders();
		return axios.put(url, parameters, {
			headers: reqHeaders
		}).then(callback).catch(errorCallback);
	}	
}


// WEBPACK FOOTER //
// ./src/Util/httpUtil.js